import NumericFilter, { type NumericFilterConfig } from './NumericFilter';

class EstimateNumericFilter extends NumericFilter {
  name?: string;

  constructor(value?: NumericFilterConfig, name?: string) {
    super(value);
    this.name = name;
  }

  matches(record) {
    if (!this.name) return true;

    return super.matches(record[this.name]?.value);
  }

  // Allows this to be used as part of DevelopBoardFilters
  setItems(value: NumericFilterConfig) {
    this.set(value);
  }
}

export default EstimateNumericFilter;
